<template>
  <div class="p-gmap">
    <GmapMap
      v-if="center !== null"
      :center="center"
      :zoom="zoom"
      map-type-id="roadmap"
      class="p-gmap--schoolarea"
    >
      <GmapInfoWindow
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
      >
        <aside class="c-infoWindow c-infoWindow--fixed-height">
          <div class="content-wrapper">
            <ul>
              <li v-for="item in openedInfoData" @click="goToDetail(item.id)" :key="item.id">
                <figure>
                  <img :src="imageRender(item.image,item.priority)" />
                </figure>
                <div>
                  <p class="c-infoWindow--price">{{item.price}}</p>
                  <p class="c-infoWindow--layout">{{ieloveLayout(item.media,item.layout)}}</p>
                  <p class="c-infoWindow--area">
                    <common-area-changer
                      :val="item.area"
                      :size="11"
                    />
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </aside>
      </GmapInfoWindow>
      <GmapMarker
        :key="index"
        v-for="(m, index) in this.drawnPositionItems"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        :data="m"
        :label="getMarkerLabel(m)"
        :icon="getMarkerIcon(m)"
        @mouseover="toggleInfoWindow(m)"
        @click="onClickMarker(m)"
      />
    </GmapMap>
    <aside class="c-attention">
      <p>※地図上に表示されているマークは、物件がその付近住所に所在することを表すものであり、実際の物件所在地とは異なる場合があります。</p>
    </aside>
    <aside v-if="isDetailView" :class="!multipleViewProperties ? 'c-infoWindow c-infoWindow--fixed-to-bottom' : 'c-infoWindow c-infoWindow--centered'" >
      <div class="content-wrapper">
        <div v-if="multipleViewProperties" class="close-icon" @click="isDetailView = false">
          <img src="@/assets/images/batsu-limit.png" alt="">
        </div>
        <ul>
          <li v-for="item in propViewDetail" @click="goToDetail(item.id)" :key="item.id">
            <figure>
              <img :src="imageRender(item.image,item.priority)" />
            </figure>
            <div>
              <p class="c-infoWindow--price">{{item.price}}</p>
              <p class="c-infoWindow--layout">{{ieloveLayout(item.media,item.layout)}}</p>
              <p class="c-infoWindow--area">
                <common-area-changer
                :val="item.area"
                :size="multipleViewProperties ? 11 : 14"
              />
              </p>
            </div>
          </li>
        </ul>
      </div>
    </aside>
  </div>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';
import CommonAreaChanger from '@/components/parts/CommonAreaChanger';

export default {
  name: 'SearchListGoogleMap',
  mixins: [IsMobileMixin],
  props: ['center', 'makerList', 'zoom', 'media'],
  components: {
    CommonAreaChanger,
  },
  computed: {
    multipleViewProperties() {
      return this.propViewDetail.length > 1;
    },
  },
  watch: {
    makerList: {
      immediate: true,
      handler() {
        const positionMap = {};
        // Group properties by stringified lat/lng
        this.makerList.forEach((marker) => {
          const positionKey = this.createPositionKey(marker.position);
          if (positionMap[positionKey]) {
            positionMap[positionKey].push(marker);
          } else {
            positionMap[positionKey] = [marker];
          }
        });

        this.drawnPositionItems = Object.keys(positionMap).map((position) => {
          const item = positionMap[position];
          return {
            position: item[0].position,
            items: item,
          };
        });
      },
    },
  },
  data() {
    return {
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -45
          ,
        },
      },
      infoWindowPos: null,
      infoWinOpen: false,
      openedInfoData: [],
      drawnPositionItems: [],
      isDetailView: false,
      propViewDetail: [],
      markerOptions: {
        // eslint-disable-next-line global-require
        url: require('@/assets/images/icon_house@2x.png'),
        size: { width: 48, height: 48, f: 'px', b: 'px' },
        scaledSize: { width: 48, height: 48, f: 'px', b: 'px' },
      },
      markerLabelOptions: {
        color: 'white',
      },
    };
  },
  methods: {
    ieloveLayout(media, layout) {
      let ret = layout;
      if (media === 'ielove') {
        ret = ret.replace('1LDK,', '');
      }
      return ret;
    },
    onClickMarker(marker) {
      if (this.isTablet || this.isMobile) {
        this.isDetailView = true;
        this.propViewDetail = marker.items;
      } else if (marker.items.length === 1) {
        // For multiple property markers, ignore click on marker itself
        this.goToDetail(marker.items[0].id);
      }
    },
    goToDetail(id) {
      location.href = `/kodate/${id}/`;
    },
    toggleInfoWindow(marker) {
      this.openedInfoData = marker.items;
      this.infoWindowPos = marker.position;
      this.infoWinOpen = true;
    },
    createPositionKey(position) {
      return `lat:${position.lat},lng:${position.lng}`;
    },
    getMarkerLabel(marker) {
      return marker.items.length > 1 ? {
        ...this.markerLabelOptions,
        text: marker.items.length.toString(),
      } : '';
    },
    getMarkerIcon(marker) {
      return marker.items.length > 1 ? {
        ...this.markerOptions,
        // eslint-disable-next-line global-require
        url: require('@/assets/icon-marker.png'),
      } : {
        ...this.markerOptions,
        // eslint-disable-next-line global-require
        url: require('@/assets/images/icon_house@2x.png'),
      };
    },
    imageRender(url, priority = 0) {
      let mode = 'prod';
      let ret;
      const querystring = window.location.search;
      const query = [...new URLSearchParams(querystring).entries()]
        .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});
      if (query.mode !== undefined) mode = query.mode;
      if ((priority === 0 || priority === '0') && mode === 'prod') {
        // eslint-disable-next-line global-require
        ret = require('@/assets/noimage.png');
      } else {
        ret = url;
      }
      return ret;
    },
  },
};
</script>

<style scoped lang='scss'>
@charset 'UTF-8';

.p-gmap .gm-style .gm-style-iw-d {
  padding: 0 !important;
}

.c-infoWindow {
  display: flex;
  width: 100%;

  .content-wrapper {
    width: 100%;
    min-width: 210px;
    display: flex;
    font-size: 11px;
    background-color: white;

    ul {
      width: 100%;
      overflow-y: scroll;

      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
      }

      li {
        display: flex;
        cursor: pointer;
        padding: 10px;
        border-radius: 4px;
        &:hover {
          opacity: .8;
          background-color: #EEEEEE;
        }
      }
    }

    figure {
      width: 54px;
      height: 54px;
      overflow: hidden;
      margin-right: 10px;
      img {
        position: initial !important;
        height: 54px;
        width: 54px;
        object-fit: cover;
      }
    }

  }

  &--price {
    font-weight: bold;
    font-size:11px;
  }
  &--layout {
    font-size:11px;
  }
  &--area {
    font-size:11px;
  }
  &--fixed-height {
    max-height: 320px;
    min-height: 0px;
  }
  &--fixed-to-bottom {
    position: absolute !important;
    height: auto;
    bottom: 0;

    .content-wrapper {
      p {
        font-size: 14px;
        margin-bottom:8px;
      }
      .c-infoWindow--price {
        font-size: 16px;
        font-weight: bold;
      }
      figure {
        width: 76px;
        height: 76px;
      }
    }
  }
  &--centered {
    position: absolute !important;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    height: calc( 100vh - 290px);

    .content-wrapper {
      z-index: 200;
      width: 315px;
      max-height: 480px;
      padding: 12px 32px;
      border-radius: 18px;
      position: relative;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.33);

      .close-icon {
        position: absolute;
        top: 8px;
        right: 8px;
        height: 24px;
        width: 24px;
      }

      ul {
        max-height: 480px;
        li {
          padding: 12px 0;

          figure {
            width: 54px;
            height: 54px;
          }

          div {
            flex: 1;
          }
        }
      }

    }
  }
}

@media screen and (max-width: 999px) {
  .c-infoWindow {
    .content-wrapper {
      ul {
        padding: 10px;
      }
      figure {
        width: 100px;
        height: 75px;

        img {
          object-fit: cover;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .p-gmap{
    width: 100vw;
    height: 100%;
    position: relative;
    z-index: 0;
    &--schoolarea {
      width: 100%;
      height: 100%;
    }
    .gm-style {
      img {
        position:absolute;
      }
    }
    *:not(table), *:not(table) * {
        position:initial;
    }
    .c-attention {
      position: absolute !important ;
      display:block;
      bottom: 27px;
      left: 6px;
      margin-right:60px;
      background-color: rgba($color: #FFF, $alpha: 0.9);
      padding:10px;
      p {
        font-size: 12px;
        color: #E83532;
        line-height: 1.4;
      }
    }
    .c-infoWindow {
      &--fixed {
        position: absolute;
      }
      .content-wrapper {
        ul {
          padding: 6px;
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 999px) {
  .p-gmap{
    height:100%;
        position: relative;

    &--schoolarea {
      width: 100%;
      height: calc(100vh - 163px);
      margin-bottom:24px
    }
    .gm-style {
      img {
        position:absolute;
      }
    }
    *:not(table), *:not(table) * {
        position:initial;
    }
    .c-attention {
      position: absolute !important ;
      display:block;
      bottom: 27px;
      left: 6px;
      margin-right:60px;
      background-color: rgba($color: #FFF, $alpha: 0.9);
      padding:10px;
      p {
        font-size: 12px;
        color: #E83532;
        line-height: 1.4;
      }
    }
    .c-infoWindow {
      &--fixed {
        position:absolute;
      }
    }
  }
}

@media screen and (min-width: 1000px) {
  .p-gmap{
    height: 100%;
        position: relative;

    &--schoolarea {
      width: 100%;
      height: 100%;
    }
    .gm-style {
      img {
        position:absolute;
      }
    }
    *:not(table), *:not(table) * {
        position:initial;
    }
    .c-attention {
      position: absolute !important ;
      display:block;
      bottom: 27px;
      left: 6px;
      margin-right:60px;
      background-color: rgba($color: #FFF, $alpha: 0.9);
      padding:10px;
      p {
        font-size: 12px;
        color: #E83532;
        line-height: 1.4;
      }
    }
  }
}

</style>
